import { useEffect, useState } from 'react';

export const useWindowSize = () => {
  const [innerWidth, setInnerWidth] = useState(
    () => (typeof window !== 'undefined' ? window.innerWidth : 0),
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setInnerWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { innerWidth };
};